import { useEffect, useState } from "react";
import { BACKEND_CONFIGURED, api, fmtPercent, isBackendNotConfigured } from "@/api";
import { sourceLabel } from "@/i18n";

const columns = [
  ["total_signals", "信号数"], ["triggered_trades", "已触发"],
  ["closed_trades", "已结算"], ["wins", "胜"], ["losses", "负"],
  ["breakeven", "保本"], ["not_triggered", "未触发"], ["open", "进行中"],
  ["ambiguous", "无法判定"], ["verified_win_rate", "验证胜率", true],
  ["tp1_hit_rate", "止盈1命中率", true], ["full_tp_rate", "全部止盈率", true],
  ["sl_rate", "止损率", true], ["be_rate", "保本率", true],
  ["manual_profit_close_rate", "手动盈利平仓率", true],
  ["report_accuracy", "报告准确率", true], ["average_r", "平均 R"],
  ["total_r", "总 R"], ["max_consecutive_losses", "最大连续亏损"],
];

export default function PerformancePage() {
  const [windowValue, setWindowValue] = useState("all");
  const [rows, setRows] = useState([]);
  const [error, setError] = useState("");

  useEffect(() => {
    let active = true;
    if (!BACKEND_CONFIGURED) {
      setRows([]);
      setError("后端尚未部署，绩效统计暂时没有真实数据。");
      return () => { active = false; };
    }

    api.get("/performance", { params: { window: windowValue } })
      .then((response) => {
        if (!active) return;
        const items = Array.isArray(response?.data?.items) ? response.data.items : [];
        setRows(items);
        setError(Array.isArray(response?.data?.items) ? "" : "绩效接口返回格式异常");
      })
      .catch((err) => {
        if (!active) return;
        setRows([]);
        setError(isBackendNotConfigured(err) ? "后端尚未部署，绩效统计暂时没有真实数据。" : "统计加载失败");
      });

    return () => { active = false; };
  }, [windowValue]);

  return (
    <section data-testid="performance-page">
      <div className="page-heading">
        <div><p className="eyebrow">市场验证绩效</p><h1>号机真实统计</h1></div>
        <label className="compact-field">周期
          <select value={windowValue} onChange={(e) => setWindowValue(e.target.value)} data-testid="performance-window-select">
            <option value="30d">30天</option><option value="60d">60天</option>
            <option value="90d">90天</option><option value="all">全部</option>
          </select>
        </label>
      </div>
      {error && <p className="error-text" data-testid="performance-error">{error}</p>}
      <div className="table-frame wide"><table data-testid="performance-table"><thead><tr>
        <th>号机（真实 KOL）</th>{columns.map(([, label]) => <th key={label}>{label}</th>)}
      </tr></thead><tbody>{rows.map((row) => {
        const source = String(row?.source || "unknown");
        return <tr key={source} data-testid={`performance-row-${source.replace(/_/g, "-")}`}>
          <td className="source-name" data-testid={`performance-source-${source.replace(/_/g, "-")}`}>{sourceLabel(source, row?.source_display)}</td>
          {columns.map(([key, , percent]) => <td key={key} className="mono" data-testid={`performance-${key.replace(/_/g, "-")}-${source.replace(/_/g, "-")}`}>
            {percent ? fmtPercent(row?.[key]) : (row?.[key] ?? "—")}
          </td>)}
        </tr>;
      })}</tbody></table></div>
      {!rows.length && !error && <p className="empty-state">暂无绩效数据。</p>}
    </section>
  );
}
